export enum BankAccountStatus {
    Unverified = 'Unverified',
    Present = 'Present',
    Missing = 'Missing'
}
